<!--
유저 리스트를 보여주는 컴포넌트, Admin의 하위
-->
<template>
  <div>
    <common-title full clearBoth>
      <pb-float float="left">
        사용자 목록
      </pb-float>

      <pb-float float="right">
        <pb-input
          v-model="search"
          size="small"
          style="width: 230px"
          placeholder="검색 [ 아이디 | 이름 ]"
          @enter="searchOnTable"
        />
      </pb-float>
    </common-title>

    <pb-table
      :columns="columns"
      :items="localy_managers"
      emptyText="-"
      @rowAction="rowClickHandler"
    >
      <template slot="index" slot-scope="item">
        {{ item.index + 1 }}
      </template>

      <template slot="delete" slot-scope="item">
        <div @click="deleteHandler(item)">
          <i class="fas fa-trash-alt"></i>
        </div>
      </template>
    </pb-table>

    <div>
      <pb-float-button fab title="추가하기" @click="toggleHandler">
        <i class="fas fa-plus"></i>
      </pb-float-button>
    </div>

    <manager-create-modal v-model="toggle" @reload="reload" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CommonTitle from "@/common/CommonTitle";
import ManagerCreateModal from "@/components/manager/ManagerCreateModal";

const searchByName = (items, term) => {
  if (term) {
    return items.filter(
      (item) =>
        (item.name != null && item.name.includes(term)) ||
        (item.id != null && item.id.includes(term))
    );
  }
  return items;
};

export default {
  name: "UserList",
  data: () => ({
    columns: [
      { key: "index", title: "#", width: 60 },
      { key: "id", title: "아이디 (ID)" },
      { key: "name", title: "이름", width: 200 },
      { key: "delete", title: "삭제", width: 100, clickabled: false },
    ],
    search: null,
    localy_managers: [],
    toggle: false,
  }),
  computed: {
    ...mapState({
      user: "user",
      managers: "managers",
    }),

    admin() {
      return this.user.position === "구성원";
    },
  },
  methods: {
    ...mapActions(["FETCH_USERS", "DELETE_USER"]),

    searchOnTable() {
      this.localy_managers = searchByName(this.managers, this.search);
    },

    async reload() {
      await this.FETCH_USERS({ hook: this.setLocalyData });
    },

    deleteHandler(user) {
      this.$confirm.show({
        title: "사용자 삭제",
        content: "삭제된 사용자는 복구가 불가합니다.<br/>삭제하시겠습니까?",
        onConfirm: () => {
          this.localy_managers = this.localy_managers.filter(
            (_, i) => i !== user.index
          );

          this.DELETE_USER({ idx: user.ksia_member });
          this.$alert.info("삭제가 완료되었습니다.");
        },
      });
    },

    toggleHandler() {
      this.toggle = !this.toggle;
    },

    setLocalyData(data) {
      this.localy_managers = data;
    },

    rowClickHandler() {},
  },
  components: {
    CommonTitle,
    ManagerCreateModal,
  },
  async created() {
    if (!this.admin) {
      this.$router.push("/campaigns");
      return;
    }

    this.reload();
  },
};
</script>

<style>
.md-content.md-table-content.md-scrollbar.md-theme-default {
  height: 75vh;
  max-height: 75vh;
}
</style>
